import { Dialog, DialogContent, DialogDescription, DialogFooter, DialogHeader, DialogTitle } from "../ui/dialog";

export const DissolveSummary = ({ result, onClose }) => (
  <Dialog open={!!result} onOpenChange={(o) => !o && onClose()}>
    <DialogContent data-testid="dissolve-summary-dialog" className="max-w-xl">
      <DialogHeader>
        <DialogTitle>Archivos repartidos</DialogTitle>
        <DialogDescription>
          {result?.clientes} {result?.clientes === 1 ? "cliente eliminado" : "clientes eliminados"} · asignados por nombre {result?.asignados} ·
          a Por clasificar {result?.por_clasificar} · <span data-testid="dissolve-summary-ya-existian">Ya existían en el expediente {result?.ya_existian ?? result?.duplicados ?? 0}</span>
        </DialogDescription>
      </DialogHeader>
      {result?.destinos.length > 0 && (
        <ul className="max-h-72 space-y-1.5 overflow-y-auto text-sm" data-testid="dissolve-summary-list">
          {result.destinos.map((d, i) => (
            <li key={d.borrower_id} className="flex justify-between gap-3 rounded-lg bg-[#f5f8fd] px-3 py-2" data-testid={`dissolve-summary-item-${i}`}>
              <span className="font-semibold text-[#182235]">{d.name} <span className="font-mono text-xs text-[#5b667a]">{d.borrower_id}</span></span>
              <span className="font-mono font-bold text-[#0f5ef7]">{d.files}</span>
            </li>
          ))}
        </ul>
      )}
      <DialogFooter>
        <button type="button" onClick={onClose} className="tr-btn-primary px-4 py-2 text-sm" data-testid="dissolve-summary-close">Entendido</button>
      </DialogFooter>
    </DialogContent>
  </Dialog>
);
